import { Grid } from "@mui/material";
import styled from "styled-components";

export const StyledDataKey = styled.label`
    color: black;
    padding: 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
`;

export const StyledDataRow = styled(Grid)`
    && {
        display: flex;
        margin-bottom: 25px;
    }
`;
